import React, { Fragment } from 'react'
import { Colors, Web_url } from '../../common/Const';
import { colors } from '@mui/material';

const CateCom = (props) => {
    const { Category, callFilter } = props;
  return (
    <div className={ "hd-cate"} style={{backgroundColor: '#f4f6f5'}}>
    {Category.data && Category.data.length > 0 && (Category.data.map((data) => {
          return <div onClick={() => callFilter(data.id)} style={{
            textAlign: 'center',
            cursor:'pointer'
          }} key={data.id}> <img src={Web_url?.web_url + data?.icon_img} style={{
            width:'35px',
            heigh:'35px'
          }} /> <p style={{color: Colors.Base_color}} >{data.category_name}</p> </div>;
        })
    )}
  </div>
  )
}

export default CateCom